import { createAction } from 'redux-actions';
import { PassengerTypeConfig } from '../../types';

export const SET_PASSENGERS_CONFIG = 'SET_PASSENGERS_CONFIG';

export const setPassengersConfig = createAction<PassengerTypeConfig[]>(SET_PASSENGERS_CONFIG);
